import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { getClubByHost, type SiteClub } from "./api";

// Which club's site is this? One lookup per page load, by hostname:
// rcccs-demo.sturgeon.tech (later rcccs.net) -> RCCCS. On the RC Race HQ
// service site (www/www-dev.rcracehq.com) there's no club and nothing is
// scoped. Club-scoped: events list, Uploads, Manage. User-scoped (same
// everywhere): Profile, Vehicles, Registrations, Credits.

interface SiteClubState {
  club: SiteClub | null;
  loading: boolean;
}

const SiteClubContext = createContext<SiteClubState>({ club: null, loading: true });

export function SiteClubProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SiteClubState>({ club: null, loading: true });

  useEffect(() => {
    // Preview a club's view from any host (localhost, www-dev):
    // ?club-host=rcccs-demo.sturgeon.tech sticks for the browser tab;
    // ?club-host= (empty) goes back to this host's own view.
    const param = new URLSearchParams(window.location.search).get("club-host");
    if (param !== null) {
      if (param) sessionStorage.setItem("club-host", param);
      else sessionStorage.removeItem("club-host");
    }
    const host = sessionStorage.getItem("club-host") || window.location.hostname;
    getClubByHost(host)
      .then((res) => setState({ club: res.club, loading: false }))
      .catch(() => setState({ club: null, loading: false }));
  }, []);

  return <SiteClubContext.Provider value={state}>{children}</SiteClubContext.Provider>;
}

export function useSiteClub(): SiteClubState {
  return useContext(SiteClubContext);
}
